<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      title="设置付费规则"
      width="500px"
      height="300px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container">
        <div class="setting-item">
          <span>整本定价：</span>
          <el-input v-model="price" type="number" size="mini"></el-input>
          <span>元</span>
        </div>
        <div class="setting-item">
          <span>文章定价：</span>
          <el-input v-model="articlePrice" type="number" size="mini"></el-input>
          <span>元/篇</span>
        </div>
        <div class="setting-item">
          <span>阅读期限：</span>
          <el-radio class="title-radio" :label="true" v-model="isPermanent">永久</el-radio>
          <el-radio class="title-radio no_text" :label="false" v-model="isPermanent"></el-radio>
          <el-input v-model="dateLimit" type="number" :disabled="isPermanent" size="mini"></el-input>
          <span>个月</span>
        </div>
        <div class="setting-item limit-item">
          <span>试读范围：</span>
          <el-radio-group v-model="trialOption">
            <el-radio :label="0"><span>前</span><el-input v-model="pageLimit" type="number" size="mini"></el-input> <span>页&nbsp;（范围内文章均可查看）</span></el-radio>
            <el-radio :disabled="articlePrice == 0 || articlePrice === null || articlePrice === ''" :label="1"
              >文章内容前&nbsp;<el-input v-model="articleLimit" type="number" size="mini"></el-input> <span>%（所有页面均可查看，但禁止缩放）</span></el-radio
            >
          </el-radio-group>
        </div>
        <!--<div class="setting-item">
          <p>在专辑、图书馆、报纸管理中整体订阅内容后，本内容是否 还需单独订阅：</p>
          <el-radio v-model="isIndividual" class="title-radio" :label="0">是</el-radio>
          <el-radio v-model="isIndividual" class="title-radio" :label="1">否</el-radio>
        </div>-->
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item left" @click="saveThen()">保存</div>
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import compareVipRight from '@components/common/compareVipRight.js'
import chargeApi from '@api/chargeManager'

export default {
  name: 'BookPrice',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      id: '',
      price: '',
      articlePrice: '',
      dateLimit: null,
      pageLimit: null,
      articleLimit: null,
      trialOption: 0,
      isIndividual: 0,
      isPermanent: true
    }
  },
  props: {
    workObj: Object
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initSetting()
      }
    }
  },
  computed: {
    bookObj() {
      return this.$store.state.config.bookObj
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    saveThen() {
      if (!this.articlePrice || this.articlePrice === '' || this.articlePrice == 0) {
        this.trialOption = 0
      }
      if (!this.price || this.price <= 0 || this.price > 99999) {
        this.$message({
          message: '请设置定价',
          type: 'error'
        })
        return
      }
      if ((this.pageLimit === null || this.pageLimit < 0 || this.pageLimit % 1 !== 0) && this.trialOption === 0) {
        this.$message({
          message: '请设置试读范围，输入0-9999的整数',
          type: 'error'
        })
        return
      } else if ((this.articleLimit === null || this.articleLimit < 0 || this.articleLimit > 100) && this.trialOption === 1) {
        this.$message({
          message: '请设置试读范围，输入0-100的整数',
          type: 'error'
        })
        return
      }
      let period = this.isPermanent ? 0 : this.dateLimit
      if (period === null || (!this.isPermanent && period <= 0) || period % 1 !== 0 || period > 99) {
        this.$message({
          message: '请设置阅读期限,输入1-99的整数',
          type: 'error'
        })
        return
      }
      if (this.trialOption === 1) {
        this.pageLimit = null
      } else if (this.trialOption === 0) {
        this.articleLimit = null
      }
      let param = {
        id: this.id,
        price: this.price,
        articlePrice: this.articlePrice,
        period: period,
        chargePage: this.pageLimit,
        trialPercent: this.articleLimit,
        trialOption: this.trialOption
      }
      chargeApi.setCharge(param).then((res) => {
        if (res.data && res.data.status === 0) {
          this.dialogVisible = false
          this.$emit('saveSuccess', 'cloud_read_ebook')
        } else {
          this.$message({
            message: res.data.message || '保存失败',
            type: 'error'
          })
        }
      })
    },
    initSetting() {
      this.id = this.workObj.id
      this.price = this.workObj.price
      this.dateLimit = this.workObj.period
      this.pageLimit = this.workObj.chargePage
      this.trialOption = this.workObj.trialOption
      this.articleLimit = this.workObj.trialPercent
      this.articlePrice = this.workObj.articlePrice
      if (this.dateLimit === 0 || this.dateLimit === null) {
        this.isPermanent = true
        this.dateLimit = null
      } else {
        this.isPermanent = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.setting-container {
  .setting-item {
    margin-bottom: 10px;
    font-size: 12px;
    &:first-child {
      .el-input {
        width: 80px;
      }
    }
    &:nth-child(2) {
      .el-input {
        width: 80px;
      }
    }
    .el-input {
      display: inline-block;
      width: 40px;
      margin-right: 10px;
    }
    span {
      margin-right: 10px;
    }
    &.limit-item {
      display: flex;
      & > :first-child {
        word-break: keep-all;
        line-height: 26px;
      }
      .el-radio {
        margin-bottom: 10px;
      }
    }
  }
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
<style lang="scss">
.setting-item {
  .el-input {
    input.el-input__inner {
      height: 26px;
      line-height: 26px;
      padding-right: 0;
      padding-left: 0;
      text-align: center;
    }
  }
  .no_text {
    .el-radio__label {
      display: none;
    }
    margin-right: 5px;
  }
}
</style>
